import React from "react";
import { RootState } from "redux/store";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { Dialog } from "component/shared/dialog";
import { styles } from "../../style";
import * as yup from "yup";
import { validate } from "shared/yup";
import { CustomAutocomplete } from "component/shared/auto-complete";
import { getAgentsWithLeads, getLeadsById } from "redux/selector";
import { updateLead } from "redux/slice/leads";
import * as env from "shared/env";


const mapStateToProps = (state: RootState, ownProps: any) => {
	return {
		agents: getAgentsWithLeads(state),
		leads: getLeadsById(state, ownProps.leadIds),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	updateLead,
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {
	onClose: Function,
	leadIds: number[],
}

interface State {
	agentId?: number;
	input: string;
	submitted: boolean;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			submitted: false,
			input: "",
		};
	}

	private validationSchema = {
		agentId: yup
			.string()
			.required("Please select an agent."),
	};

	private assignAgent() {
		const { leads, agents, updateLead } = this.props;
		const { agentId } = this.state;
		const errors = validate(this.validationSchema, this.state);

		if (!errors && agentId) {
			leads.forEach((lead) => {
				const agent = agents.find(item => item.id === agentId);
				if (agent) {
					if (!lead.agent || (lead.agent.id !== agent.id)) {
						updateLead({ lead: {
							...lead,
							agent,
						}});
					}
				}
			});
			this.onClose();
		} else {
			this.setState({ submitted: true });
		}
	}

	private onClose() {
		this.props.onClose();
		this.setState({ agentId: undefined, input: "", submitted: false });
	}

	render() {
		const { classes = {} } = this.props;
		const { agentId, input, submitted } = this.state;
		const agentOptions = this.props.agents.map((agent) => ({
			value: agent.id,
			label: agent.name || agent.label,
		}));
		return (
			<Dialog
				open={true}
				onClose={() => {
					this.onClose()
				}}
				fullWidth={true}
				maxWidth="xs"
			>
				<Mui.DialogTitle>Assign to Agent</Mui.DialogTitle>
				<Mui.DialogContent dividers className={classes.dialogContent}>
					<Mui.Grid container alignItems="center" spacing={1}>
						<Mui.Grid item xs={12}>
							<Mui.DialogContentText className={classes.dialogText}>Assign all selected contacts to an agent.</Mui.DialogContentText>
						</Mui.Grid>
						<Mui.Grid item xs={12}>
							<CustomAutocomplete
								options={agentOptions}
								textInputHeight={true}
								label="Select Agent"
								optionLabelExtractor={(option) => option.label}
								fullWidth
								margin="dense"
								placeholder="Select an agent"
								onInputChange={(event, value, reason) => {
									if (reason === "reset") {
										this.setState({ input: "" });
									} else {
										this.setState({ input: value });
									}
								}}
								onChange={(event, option) => {
									if (option && option.value) {
										this.setState({ agentId: option.value as number, input: option.label });
									}
								}}
								inputValue={input}
								helperText={submitted && !agentId ? "Please select an agent." : undefined}
							/>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.DialogContent>
				<Mui.DialogActions className={classes.dialogActions}>
				<Mui.Button 
						onClick={() => {
							this.onClose();
						}}
						variant="outlined"
						color={"primary"}
					>
						Cancel
					</Mui.Button>
					<Mui.Button
						onClick={() => {
							this.assignAgent();
						}}
						variant="contained"
						color={"primary"}
						disabled={submitted && !agentId}
					>
						Save
					</Mui.Button>
				</Mui.DialogActions>
			</Dialog>
		)
	}

}

export const BulkAssignToAgentDialog = withStyles(connect(mapStateToProps, mapDispatchToProps)(Component), styles);